import { ListItem, ListItemText, Stack } from "@mui/material";
import React, { ReactNode } from "react";

import { NumberedList } from "components/common/NumberedList/NumberedList";

import { Modal } from "./Modal";

type GuidanceModalProps = {
  open: boolean;
  title: string;
  subtitle: string;
  onClose: () => void;
  onConfirmation: () => void;
  image: ReactNode;
  steps: ReactNode[];
};

export function GuidanceModal({ open, onClose, onConfirmation, image, steps, title, subtitle }: GuidanceModalProps) {
  return (
    <Modal
      title={title}
      subtitle={subtitle}
      open={open}
      onClose={onClose}
      onConfirmation={onConfirmation}
      size="medium"
      body={
        <Stack direction="row" justifyContent="center" alignItems="center">
          <NumberedList>
            {steps.map((step) => (
              <ListItem>
                <ListItemText primary={step} />
              </ListItem>
            ))}
          </NumberedList>

          {image}
        </Stack>
      }
    />
  );
}
